import { render, staticRenderFns } from "./SectionSubTitle.vue?vue&type=template&id=2222922b&"
import script from "./SectionSubTitle.vue?vue&type=script&lang=js&"
export * from "./SectionSubTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports